import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import reduxThunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import $ from 'jquery';

import WP from 'WP';

import { msg, gtmPush, cookie, isValidDate, getFutureDate } from 'helpers';

/*
|--------------------------------------------------------------------------
|  MENUS REDUCER
|--------------------------------------------------------------------------
|
*/
const menusReducer = (state = {}, action) => {
    switch (action.type) {
        case 'ADD_MENU_TO_STORE':
            return { ...state, [action.payload.location]: action.payload.menu };
        default:
            return state;
    }
}

/*
|--------------------------------------------------------------------------
|  CURRENT VIEW REDUCER
|--------------------------------------------------------------------------
|
*/
const currentViewReducer = (state = null, action) => {
    switch (action.type) {
        case 'SET_CURRENT_VIEW':
            return action.payload;
        default:
            return state;
    }
}

export const setCurrentView = view => dispatch => {
    dispatch({ type: 'SET_CURRENT_VIEW', payload: view });
}

/*
|--------------------------------------------------------------------------
|  PRODUCT SEARCH KEYWORD REDUCER
|--------------------------------------------------------------------------
|
*/
const productSearchKeywordReducer = (state = '', action) => {
    switch (action.type) {
        case 'SET_PRODUCT_SEARCH_KEYWORD':
            return action.payload;
        default:
            return state;
    }
}

export const setProductSearchKeyword = val => dispatch => {
    dispatch({ type: 'SET_PRODUCT_SEARCH_KEYWORD', payload: val });
}

const productsFilterDefault = {
    delivery: null,
    academicArea: null,
    category: null,
    type: null,
    objectType: null,
    program: null,
    course: null,
}

const productsFilterReducer = (state = productsFilterDefault, action) => {
    switch (action.type) {
        case 'SET_PRODUCT_DELIVERY_FILTER':
            return { ...state, delivery: action.payload };
        case 'SET_PRODUCT_ACADEMIC_AREA_FILTER':
            return { ...state, academicArea: action.payload };
        case 'SET_PRODUCT_CATEGORY_FILTER':
            return { ...state, category: action.payload };
        case 'SET_PRODUCT_TYPE_FILTER':
            return { ...state, type: action.payload };
        case 'SET_PRODUCT_OBJECT_TYPE_FILTER':
            return { ...state, objectType: action.payload };
        case 'SET_PRODUCT_PROGRAM_FILTER':
            return { ...state, program: action.payload };
        case 'SET_PRODUCT_COURSE_FILTER':
            return { ...state, course: action.payload };
        case 'RESET_PRODUCT_FILTER':
            return productsFilterDefault;
        default:
            return state;
    }
}

export const setProductDeliveryFilter = delivery => dispatch => {
    dispatch({ type: 'SET_PRODUCT_DELIVERY_FILTER', payload: delivery });
}

export const setProductAcademicAreaFilter = academicArea => dispatch => {
    dispatch({ type: 'SET_PRODUCT_ACADEMIC_AREA_FILTER', payload: academicArea });
}

export const setProductCategoryFilter = category => dispatch => {
    dispatch({ type: 'SET_PRODUCT_CATEGORY_FILTER', payload: category });
}

export const setProductTypeFilter = type => dispatch => {
    dispatch({ type: 'SET_PRODUCT_TYPE_FILTER', payload: type });
}

export const setProductObjectTypeFilter = objectType => dispatch => {
    dispatch({ type: 'SET_PRODUCT_OBJECT_TYPE_FILTER', payload: objectType });
}

export const setProductProgramFilter = program => dispatch => {
    dispatch({ type: 'SET_PRODUCT_PROGRAM_FILTER', payload: program });
}

export const setProductCourseFilter = course => dispatch => {
    dispatch({ type: 'SET_PRODUCT_COURSE_FILTER', payload: course });
}

export const resetProductsFilter = () => dispatch => {
    dispatch({ type: 'RESET_PRODUCT_FILTER', payload: null });
}

/*
|--------------------------------------------------------------------------
|  PAGES REDUCER
|--------------------------------------------------------------------------
|
*/
const pagesReducer = (state = {}, action) => {
    switch (action.type) {
        case 'ADD_TO_PAGES':
            return { ...state, [action.payload.key]: action.payload.page };
        default:
            return state;
    }
}

/*
|--------------------------------------------------------------------------
|  COURSES REDUCER
|--------------------------------------------------------------------------
| NOTE: actions (SET_XXX, SET_XXX_ALL_LOADED_FLAG, SET_XXX_LATEST_LOADED_FLAG)
| are "auto generated" by PostFetcher instance so they do not have to be specified here
*/
const coursesReducer = (state = { posts: [], allLoaded: false, latestLoaded: false }, action) => {
    switch (action.type) {
        case 'SET_COURSES':
            return { ...state, posts: action.payload };
        case 'SET_COURSES_ALL_LOADED_FLAG':
            return { ...state, allLoaded: action.payload };
        case 'SET_COURSES_LATEST_LOADED_FLAG':
            return { ...state, latestLoaded: action.payload };
        default:
            return state;
    }
}

const programsReducer = (state = { posts: [], allLoaded: false, latestLoaded: false }, action) => {
    switch (action.type) {
        case 'SET_PROGRAMS':
            return { ...state, posts: action.payload };
        case 'SET_PROGRAMS_ALL_LOADED_FLAG':
            return { ...state, allLoaded: action.payload };
        case 'SET_PROGRAMS_LATEST_LOADED_FLAG':
            return { ...state, latestLoaded: action.payload };
        default:
            return state;
    }
}

/*
|--------------------------------------------------------------------------
|  BLOG POST REDUCER
|--------------------------------------------------------------------------
| NOTE: actions (SET_XXX, SET_XXX_ALL_LOADED_FLAG, SET_XXX_LATEST_LOADED_FLAG)
| are "auto generated" by PostFetcher instance so they do not have to be specified here
*/
const blogReducer = (state = { posts: [], allLoaded: false, latestLoaded: false }, action) => {
    switch (action.type) {
        case 'SET_BLOG':
            return { ...state, posts: action.payload };
        default:
            return state;
    }
}

/*
|--------------------------------------------------------------------------
|  PRIVATE_TUTORING REDUCER
|--------------------------------------------------------------------------
| NOTE: actions (SET_XXX, SET_XXX_ALL_LOADED_FLAG, SET_XXX_LATEST_LOADED_FLAG)
| are "auto generated" by PostFetcher instance so they do not have to be specified here
*/
const privateTutoringReducer = (state = { posts: [], allLoaded: false, latestLoaded: false }, action) => {
    switch (action.type) {
        case 'SET_PRIVATETUTORING':
            return { ...state, posts: action.payload };
        case 'SET_PRIVATETUTORING_ALL_LOADED_FLAG':
            return { ...state, allLoaded: action.payload };
        case 'SET_PRIVATETUTORING_LATEST_LOADED_FLAG':
            return { ...state, latestLoaded: action.payload };
        default:
            return state;
    }
}

/*
|--------------------------------------------------------------------------
|  IMPORTANT DATES REDUCER
|--------------------------------------------------------------------------
| NOTE: actions (SET_XXX, SET_XXX_ALL_LOADED_FLAG, SET_XXX_LATEST_LOADED_FLAG)
| are "auto generated" by PostFetcher instance so they do not have to be specified here
*/
const importantDatesReducer = (state = {
    posts: [],
    allLoaded: false,
    latestLoaded: false
}, action) => {
    switch (action.type) {
        case 'SET_IMPORTANTDATES':
            return { ...state, posts: action.payload };
        case 'SET_IMPORTANTDATES_ALL_LOADED_FLAG':
            return { ...state, allLoaded: action.payload };
        case 'SET_IMPORTANTDATES_LATEST_LOADED_FLAG':
            return { ...state, latestLoaded: action.payload };
        default:
            return state;
    }
}

/*
|--------------------------------------------------------------------------
|  SLOT (timeplan) REDUCER
|--------------------------------------------------------------------------
| NOTE: actions (SET_XXX, SET_XXX_ALL_LOADED_FLAG, SET_XXX_LATEST_LOADED_FLAG)
| are "auto generated" by PostFetcher instance so they do not have to be specified here
*/
const slotsReducer = (state = { posts: [], allLoaded: false, latestLoaded: false }, action) => {
    switch (action.type) {
        case 'SET_SLOTS':
            return { ...state, posts: action.payload };
        case 'SET_SLOTS_ALL_LOADED_FLAG':
            return { ...state, allLoaded: action.payload };
        case 'SET_SLOTS_LATEST_LOADED_FLAG':
            return { ...state, latestLoaded: action.payload };
        default:
            return state;
    }
}

/*
|--------------------------------------------------------------------------
|  EMNE TAXONOMY REDUCER
|--------------------------------------------------------------------------
*/
const emneReducer = (state = {
    posts: [],
    allLoaded: false,
    latestLoaded: false
}, action) => {
    switch (action.type) {
        case 'SET_EMNE':
            return { ...state, posts: action.payload };
        case 'SET_EMNE_ALL_LOADED_FLAG':
            return { ...state, allLoaded: action.payload };
        case 'SET_EMNE_LATEST_LOADED_FLAG':
            return { ...state, latestLoaded: action.payload };
        default:
            return state;
    }
}


/*
|--------------------------------------------------------------------------
|  Kategori TAXONOMY REDUCER
|--------------------------------------------------------------------------
*/
const kategoriReducer = (state = {
    posts: [],
    allLoaded: false,
    latestLoaded: false }, action) => {
    switch(action.type) {
        case 'SET_KATEGORI' :
            return { ...state, posts: action.payload };
        default :
            return state;
    }
}

/*
|--------------------------------------------------------------------------
|  CATEGORIES TAXONOMY REDUCER
|--------------------------------------------------------------------------
*/
const categoriesReducer = (state = {
    posts: [],
    allLoaded: false,
    latestLoaded: false
}, action) => {
    switch (action.type) {
        case 'SET_CATEGORIES':
            return { ...state, posts: action.payload };
        case 'SET_CATEGORIES_ALL_LOADED_FLAG':
            return { ...state, allLoaded: action.payload };
        case 'SET_CATEGORIES_LATEST_LOADED_FLAG':
            return { ...state, latestLoaded: action.payload };
        default:
            return state;
    }
}

/*
|--------------------------------------------------------------------------
|  CATEGORIES TAXONOMY REDUCER
|--------------------------------------------------------------------------
*/
const academicAreasReducer = (state = {
    posts: [],
    allLoaded: false,
    latestLoaded: false
}, action) => {
    switch (action.type) {
        case 'SET_ACADEMICAREAS':
            return { ...state, posts: action.payload };
        case 'SET_ACADEMICAREAS_ALL_LOADED_FLAG':
            return { ...state, allLoaded: action.payload };
        case 'SET_ACADEMICAREAS_LATEST_LOADED_FLAG':
            return { ...state, latestLoaded: action.payload };
        default:
            return state;
    }
}

/*
|--------------------------------------------------------------------------
|  fagkategori TAXONOMY REDUCER
|--------------------------------------------------------------------------
*/
const fagkategoriReducer = (state = [], action) => {
    switch (action.type) {
        case 'SET_FAGKATEGORI':
            return action.payload;
        default:
            return state;
    }
}

/*
|--------------------------------------------------------------------------
|  Employees REDUCER
|--------------------------------------------------------------------------
*/
const employeesReducer = (state = { posts: [], allLoaded: false, latestLoaded: false }, action) => {
    switch (action.type) {
        case 'SET_ANSATTE':
            return { ...state, posts: action.payload };
        default:
            return state;
    }
}

/*
|--------------------------------------------------------------------------
|  CALCULATOR REDUCER
|--------------------------------------------------------------------------
|
*/
const calculatorDefaultState = {
    selectedSet: '',
    sets: [],
    programs: [],
    yearBorn: '',
    pointSummary: {},
    additionalPoints: {},
    courseOfStudy: '',
    summaryVisible: false
}

const calculatorReducer = (state = calculatorDefaultState, action) => {
    switch (action.type) {
        case 'SET_CALCULATOR_SETS':
            return { ...state, sets: action.payload };
        case 'ADD_PROGRAM_TO_CALCULATOR':
            return { ...state, programs: [...state.programs, action.payload] };
        case 'SET_CALCULATOR_PROGRAMS':
            return { ...state, programs: action.payload };
        case 'REMOVE_PROGRAM_FROM_CALCULATOR':
            return { ...state, programs: state.programs.filter(p => p.code !== action.payload.code) };
        case 'UPDATE_CALCULATOR_PROGRAM':
            return { ...state, programs: state.programs.map(p => p.code === action.payload.code ? action.payload : p) };
        case 'SET_CALCULATOR_YEAR_BORN':
            return { ...state, yearBorn: action.payload };
        case 'SET_CALCULATOR_ADDITIONAL_POINTS':
            return { ...state, additionalPoints: action.payload };
        case 'SET_CALCULATOR_POINT_SUMMARY':
            return { ...state, pointSummary: action.payload };
        case 'SET_SELECTED_PROGRAM_POST':
            return { ...state, selectedSet: action.payload };
        case 'SET_SUMMARY_VISIBLE_VALUE':
            return { ...state, summaryVisible: action.payload };
        case 'SET_COURSE_OF_STUDY_VALUE':
            return { ...state, courseOfStudy: action.payload };
        default:
            return state;
    }
}

export const setCalculatorSets = sets => dispatch => {
    dispatch({ type: 'SET_CALCULATOR_SETS', payload: sets });
}

export const addProgramToCalculator = program => dispatch => {
    dispatch({ type: 'ADD_PROGRAM_TO_CALCULATOR', payload: program });
}

export const setCalculatorPrograms = programs => dispatch => {
    dispatch({ type: 'SET_CALCULATOR_PROGRAMS', payload: programs });
}

export const removeProgramFromCalculator = program => dispatch => {
    dispatch({ type: 'REMOVE_PROGRAM_FROM_CALCULATOR', payload: program });
}

export const updateCalculatorProgram = program => dispatch => {
    dispatch({ type: 'UPDATE_CALCULATOR_PROGRAM', payload: program });
}

export const setCalculatorYearBorn = year => dispatch => {
    dispatch({ type: 'SET_CALCULATOR_YEAR_BORN', payload: year });
}

export const setCalculatorAdditionalPoints = additionalPoints => dispatch => {
    dispatch({ type: 'SET_CALCULATOR_ADDITIONAL_POINTS', payload: additionalPoints });
}

export const setCalculatorPointSummary = summary => dispatch => {
    dispatch({ type: 'SET_CALCULATOR_POINT_SUMMARY', payload: summary });
}

export const setSelectedProgramPost = title => dispatch => {
    dispatch({ type: 'SET_SELECTED_PROGRAM_POST', payload: title });
}

export const setSummaryVisibleValue = bool => dispatch => {
    dispatch({ type: 'SET_SUMMARY_VISIBLE_VALUE', payload: bool });
}

export const setCourseOfStudyValue = value => dispatch => {
    dispatch({ type: 'SET_COURSE_OF_STUDY_VALUE', payload: value });
}


/*
|--------------------------------------------------------------------------
|  BOOK MEETING REDUCER
|--------------------------------------------------------------------------
|
*/
const { carear_goals } = WP.options;

const bookMeetingReducerState = {
    progressCollapsed: false,
    visible: false,
    step: 1,
    goal: carear_goals && carear_goals[0] ? carear_goals[0].goal : '',
    meetingType: null,
    timeSlot: null,
    contactDetails: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
    },
    files: [],
    reference: null,
    editedBookingTimeSlotBackup: null,
}

const bookMeetingReducer = (state = bookMeetingReducerState, action) => {
    switch (action.type) {
        case 'SET_BOOKING_VISIBILITY':
            return { ...state, visible: action.payload };
        case 'SET_BOOKING_COLLAPSED_VALUE':
            return { ...state, progressCollapsed: action.payload };
        case 'SET_BOOKING_STEP':
            return { ...state, step: action.payload };
        case 'SET_BOOKING_GOAL':
            return { ...state, goal: action.payload };
        case 'SET_BOOKING_MEETING_TYPE':
            return { ...state, meetingType: action.payload };
        case 'SET_BOOKING_TIME_SLOT':
            return { ...state, timeSlot: action.payload };
        case 'SET_EDITED_BOOKING_TIME_SLOT_BACKUP':
            return { ...state, editedBookingTimeSlotBackup: action.payload };
        case 'SET_BOOKING_CONTACT_DETAILS':
            return { ...state, contactDetails: action.payload };
        case 'SET_BOOKING_FILES':
            return { ...state, files: action.payload };
        case 'CLEAR_BOOKING':
            return { ...bookMeetingReducerState, visible: state.visible, step: state.step };
        case 'RESET_BOOKING_STATE':
            return bookMeetingReducerState;
        case 'SET_BOOKING_REFERENCE':
            return { ...state, reference: action.payload };
        default:
            return state;
    }
}

export const setBookingVisibility = visible => dispatch => {
    if (visible) {
        $('body').addClass('oh');
    } else {
        $('body').removeClass('oh');
    }
    dispatch({ type: 'SET_BOOKING_VISIBILITY', payload: visible });
}

export const setBookingProgressCollapsedValue = collapsed => dispatch => {
    dispatch({ type: 'SET_BOOKING_COLLAPSED_VALUE', payload: collapsed });
}

export const setBookingStep = step => dispatch => {
    dispatch({ type: 'SET_BOOKING_STEP', payload: step });
}

export const setBookingGoal = goal => dispatch => {
    dispatch({ type: 'SET_BOOKING_GOAL', payload: goal });
}

export const setBookingMeetingType = type => dispatch => {
    dispatch({ type: 'SET_BOOKING_MEETING_TYPE', payload: type });
}

export const setBookingTimeSlot = slot => dispatch => {
    dispatch({ type: 'SET_BOOKING_TIME_SLOT', payload: slot });
}

export const setEditedBookingTimeSlotBackup = slot => dispatch => {
    dispatch({ type: 'SET_EDITED_BOOKING_TIME_SLOT_BACKUP', payload: slot });
}

export const setBookingContactDetails = details => dispatch => {
    dispatch({ type: 'SET_BOOKING_CONTACT_DETAILS', payload: details });
}

export const setBookingFiles = files => dispatch => {
    dispatch({ type: 'SET_BOOKING_FILES', payload: files });
}

export const clearBooking = () => dispatch => {
    dispatch({ type: 'CLEAR_BOOKING', payload: null });
}

export const setBookingReference = reference => dispatch => {
    dispatch({ type: 'SET_BOOKING_REFERENCE', payload: reference });
}

export const resetBookingState = () => dispatch => {
    dispatch({ type: 'RESET_BOOKING_STATE', payload: null });
}

/*
|--------------------------------------------------------------------------
|  CART REDUCER
|--------------------------------------------------------------------------
|
*/
const cartDefaultState = {
    collapsed: false,
    items: [],
    total: 0,
    maxPrice: 0,
    warning: '',
    isTimeplan: false,
}

const cartReducer = (state = cartDefaultState, action) => {

    let cartItems = state.items;

    const calculateTotal = cartItems => {
        return cartItems.reduce((acc, item) => {
            return acc + item.price;
        }, 0);
    }

    const calculateMaxPrice = cartItems => {
        const maxPricesByStudium = (WP.options.max_price_set || []).reduce((acc, item) => {
            return { ...acc, [item.Studium_Navn]: item.MaxSum };
        }, {});

        let values = {
            maxPrice: 0,
            warning: '',
        }

        if (cartItems.length === 0) return values;

        if (Object.keys(maxPricesByStudium).length > 0) {

            /*
            * if item.maxPriceType === "Fag-Pakke" (on at least one item in the cart)
            * maxPrice for entire cart = price (item.price) of the item with maxPriceType === "Fag-Pakke"
            *
            * if there are more than one items with item.maxPriceType === "Fag-Pakke" take the highest item.price (among items with maxPriceType === "Fag-Pakke")
            *
            * exapmple:
            * - package A : [price = 10 000] [maxPriceType = 'Fag-Pakke']
            * - package B : [price = 15 000] [maxPriceType = 'Fag-Pakke']
            * ------------
            * max price for those 2 would be the highest pice of individual item in the cart maxPriceType = 'Fag-Pakke' (in this case 15 000)
            * IMPORTANT: in that case show worning meesage about conflicting packages - note to contact bjorkness about it
            *
            * example with mixed courses:
            * - package A [maxPriceType = "Studium"] max. price for studium "Helårig" is 76 000 (based on max prices from options - see below)
            * - package B [maxPriceType = "Fag-Pakke"] max. price from "item.price" is 50 000
            * - package C [maxPriceType = "Fag-Pakke"] max. price from "item.price" is 60 000
            * ------------
            * max price for those 3 would be highest available "Fag_pake" (course with maxPriceType = "Fag-Pakke") item price (in this case 60 000)
            * IMPORTANT: in that case show worning meesage about conflicting packages - note to contact bjorkness about it
            *            *
            *  ... look at "studium" property on each item in cart and based on item.studium value get max price for that studium from maxPricesByStudium
            * ... (for item with maxPriceType === "Fag-Pakke" & studium === "Halvårig" we get max price from maxPricesByStudium[item.studium] )
            *
            * IMPORTANT: if max price for given studium (in maxPricesByStudium) is 0 - that means that THERE IS NO MAX PRICE
            *
            * if items in cart have different "studium" values (and therefor will have different max prices based on maxPricesByStudium) we take the highest max price available
            *
            * eaxmple:
            * - package A - max. price based on studium "Helårig" is 76 000 (item.price = 50 000)
            * - package B - max. price based on studium "Helårig" is 76 000 (ite.price = 30 000)
            * - package C - max. price based on studium "Halvårig vår" is 90 000 (item.price = 95 000)
            * ------------
            * max price for total items in the cart is 90 000 (highest max price form the set)
            * IMPORTANT: if there courses from more than one studium - show worning meesage about conflicting packages - note to contact bjorkness about it
            */
            if (!values.maxPrice) {
                values.warning = '';
                values.maxPrice = cartItems.reduce((acc, item) => {
                    return (item.maxPriceType === 'Studium' && maxPricesByStudium[item.studium] && maxPricesByStudium[item.studium] > acc) ? maxPricesByStudium[item.studium] : acc;
                }, 0);

                // if cart contains items with mixed studium values - set waring messaage
                const uniqueStudiumsFromCart = cartItems.map(item => item.studium).filter((item, index, array) => array.indexOf(item) === index);
                // if cart contains items with mixed studium values - set waring messaage
                if (uniqueStudiumsFromCart.length > 1) {
                    values.warning = msg('courseCombinationIssue');
                }
            }

            /*
            * OK, at this point we should have th emax price calculated, now lets check if we need to make some adjustments to it
            * if in cart there are ites that have maxPriceType === 'Fag-Pakke' we need to calculate thier total price and add it TO the max price
            * (new rule applied on 01.03.2019)
            */
            if (values.maxPrice) {
                const totalPriceOfFagPakkeCourses = cartItems.reduce((acc, item) => {
                    if (item.maxPriceType === 'Fag-Pakke') acc = acc + item.price;
                    return acc
                }, 0);
                values.maxPrice = values.maxPrice + totalPriceOfFagPakkeCourses;
            }
        }

        return values;
    }

    switch (action.type) {
        case 'SET_CART_COLLAPSED_VALUE':
            return { ...state, collapsed: action.payload };
        case 'ADD_CART_ITEM':
            cartItems = [...state.items, action.payload];
            return { ...state, items: cartItems, total: calculateTotal(cartItems), ...calculateMaxPrice(cartItems) };
        case 'REMOVE_CART_ITEM':
            cartItems = state.items.filter(item => item.post.id !== action.payload);
            return { ...state, items: cartItems, total: calculateTotal(cartItems), ...calculateMaxPrice(cartItems) };
        case 'UPDATE_CART_ITEM':
            cartItems = state.items.map(item => {
                if (item.post.id === action.payload.post.id) {
                    item = action.payload;
                }
                return item;
            });
            return { ...state, items: cartItems };
        case 'CLEAR_CART':
            return { ...state, items: [], total: 0, maxprice: 0, warning: '' };
        case 'RESET_CART':
            return cartDefaultState;
        case 'UPDATE_TOTALS':
            return { ...state, total: calculateTotal(state.items), ...calculateMaxPrice(state.items) };
        case 'SET_TIMEPLAN':
            return { ...state, isTimeplan: action.payload };
        default:
            return state;
    }
}

export const setCartCollapsedValue = collapsed => dispatch => {
    dispatch({ type: 'SET_CART_COLLAPSED_VALUE', payload: collapsed });
}

export const addCartItem = item => dispatch => {

    gtmPush({
        'event': 'addToCart',
        'ecommerce': {
            'currencyCode': 'NOK',
            'add': {
                'products': [{
                    'name': item.pakke,
                    'id': item.id,
                    'price': item.price,
                    'brand': 'bjorknesprivatskole',
                    'category': item.emne,
                    'variant': item.period,
                    'quantity': 1
                }]
            }
        }
    })

    dispatch({ type: 'ADD_CART_ITEM', payload: item });
}

export const removeCartItem = item => dispatch => {

    gtmPush({
        'event': 'removeFromCart',
        'ecommerce': {
            'currencyCode': 'NOK',
            'add': {
                'products': [{
                    'name': item.pakke,
                    'id': item.id,
                    'price': item.price,
                    'brand': 'bjorknesprivatskole',
                    'category': item.emne,
                    'variant': item.period,
                    'quantity': 1
                }]
            }
        }
    })

    dispatch({ type: 'REMOVE_CART_ITEM', payload: item.post.id });
}

export const updateCartItem = item => dispatch => {
    dispatch({ type: 'UPDATE_CART_ITEM', payload: item })
}

export const clearCart = () => dispatch => {
    dispatch({ type: 'CLEAR_CART', payload: null });
}

export const resetCart = () => dispatch => {
    dispatch({ type: 'RESET_CART', payload: null });
}

export const updateTotals = () => dispatch => {
    dispatch({ type: 'UPDATE_TOTALS', payload: null });
}

export const setTimeplan = isTimeplan => dispatch => {
    dispatch({ type: 'SET_TIMEPLAN', payload: isTimeplan });
}

/*
|--------------------------------------------------------------------------
|  CHECKOUT REDUCER
|--------------------------------------------------------------------------
|
*/
const checkoutDefault = {
    visible: false,
    step: 0,
    initStep: 0,
    title: '',
    subtitle: '',
    nextCallback: null,
    nextTitle: 'Neste',
    loading: false,
    termsAccepted: false,
    termsVisible: true,
    minimizeButton: true,
    closeButton: true,
    returnButton: true,
    error: null,
    showAdvisor: true
}

const checkoutReducer = (state = checkoutDefault, action) => {
    switch (action.type) {
        case 'SET_CHECKOUT_VISIBILITY':
            return { ...state, visible: action.payload };
        case 'SET_CHECKOUT_STEP':
            return { ...state, step: action.payload };
        case 'SET_CHECKOUT_INIT_STEP':
            return { ...state, initStep: action.payload };
        case 'SET_CHECKOUT_TITLE':
            return { ...state, title: action.payload };
        case 'SET_CHECKOUT_SUBTITLE':
            return { ...state, subtitle: action.payload };
        case 'SET_CHECKOUT_NEXT_CALBACK':
            return { ...state, nextCallback: action.payload };
        case 'SET_CHECKOUT_LOADING':
            return { ...state, loading: action.payload };
        case 'SET_CHECKOUT_TERMS_ACCEPTED':
            return { ...state, termsAccepted: action.payload };
        case 'SET_CHECKOUT_TERMS_VISIBLE':
            return { ...state, termsVisible: action.payload };
        case 'SET_CHECKOUT_MINIMIZE_BUTTON':
            return { ...state, minimizeButton: action.payload };
        case 'SET_CHECKOUT_CLOSE_BUTTON':
            return { ...state, closeButton: action.payload };
        case 'SET_CHECKOUT_RETURN_BUTTON':
            return { ...state, returnButton: action.payload };
        case 'SET_CHECKOUT_ERROR':
            return { ...state, error: action.payload.message, showAdvisor: action.payload.showAdvisor };
        case 'RESET_CHECKOUT':
            return checkoutDefault;
        case 'RESET_CHECKOUT_ERROR':
            return { ...state, error: null, showAdvisor: true };
        default:
            return state;
    }
}

export const setCheckoutVisibility = visible => dispatch => {
    if (visible) {
        $('body').addClass('oh');
    } else {
        $('body').removeClass('oh');
    }

    dispatch({ type: 'SET_CHECKOUT_VISIBILITY', payload: visible });
}

export const setCheckoutStep = (step) => dispatch => {
    cookie.set('shoppingCartStep', step, 1);
    dispatch({ type: 'SET_CHECKOUT_STEP', payload: step });
}

export const setCheckoutInitStep = initStep => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_INIT_STEP', payload: initStep });
}

export const setCheckoutTitle = title => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_TITLE', payload: title });
}

export const setCheckoutSubtitle = subtitle => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_SUBTITLE', payload: subtitle });
}

export const setCheckoutNextCallback = nextCallback => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_NEXT_CALBACK', payload: nextCallback });
}

export const setCheckoutLoading = loading => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_LOADING', payload: loading });
}

export const setTermsVisibility = visible => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_TERMS_VISIBLE', payload: visible });
}

export const setTermsAccepted = accepted => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_TERMS_ACCEPTED', payload: accepted });
}

export const setCheckoutMinimizeButton = minimizeButton => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_MINIMIZE_BUTTON', payload: minimizeButton });
}

export const setCheckoutCloseButton = closeButton => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_CLOSE_BUTTON', payload: closeButton });
}

export const setCheckoutReturnButton = returnButton => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_RETURN_BUTTON', payload: returnButton });
}

export const setCheckoutError = (error, showAdvisor = true) => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_ERROR', payload: { message: error, showAdvisor } });
}

export const resetCheckout = () => dispatch => {
    dispatch({ type: 'RESET_CHECKOUT', payload: null });
}

export const resetCheckoutError = () => dispatch => {
    dispatch({ type: 'RESET_CHECKOUT_ERROR', payload: null });
}

const customerDefault = {
    id: null,
    firstName: null,
    lastName: null,
    personalNumber: null,
    email: null,
    phone: null,
    country: null,
    city: null,
    street: null,
    postalCode: null,
    partialObject: false,
}

const customerReducer = (state = customerDefault, action) => {
    switch (action.type) {
        case 'SET_CHECKOUT_CUSTOMER':
            return action.payload;
        case 'SET_CHECKOUT_CUSTOMER_ID':
            return { ...state, id: action.payload };
        case 'SET_CHECKOUT_CUSTOMER_FIRST_NAME':
            return { ...state, firstName: action.payload };
        case 'SET_CHECKOUT_CUSTOMER_LAST_NAME':
            return { ...state, lastName: action.payload };
        case 'SET_CHECKOUT_CUSTOMER_PERSONAL_NUMBER':
            return { ...state, personalNumber: action.payload };
        case 'SET_CHECKOUT_CUSTOMER_EMAIL':
            return { ...state, email: action.payload };
        case 'SET_CHECKOUT_CUSTOMER_PHONE':
            return { ...state, phone: action.payload };
        case 'SET_CHECKOUT_CUSTOMER_COUNTRY':
            return { ...state, country: action.payload };
        case 'SET_CHECKOUT_CUSTOMER_CITY':
            return { ...state, city: action.payload };
        case 'SET_CHECKOUT_CUSTOMER_POSTAL_CODE':
            return { ...state, postalCode: action.payload };
        case 'SET_CHECKOUT_CUSTOMER_PARTIAL_OBJECT':
            return { ...state, partialObject: action.payload };
        case 'RESET_CHECKOUT_CUSTOMER':
            return customerDefault;
        default:
            return state;
    }
}

export const setCheckoutCustomer = customer => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_CUSTOMER', payload: customer });
}

export const setCheckoutCustomerId = id => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_CUSTOMER_ID', payload: id });
}

export const setCheckoutCustomerPartialObject = partialObject => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_CUSTOMER_PARTIAL_OBJECT', payload: partialObject });
}

export const resetCheckoutCustomer = () => dispatch => {
    dispatch({ type: 'RESET_CHECKOUT_CUSTOMER', payload: null });
}

const opportunityDefault = {
    id: null,
    customerId: null,
    educationalGoal: null,
    attachments: [],
    skipAttachments: null,
    comment: null,
    programs: [],
    courses: [],
    transactionId: null,
    amount: 0,
    payableAmount: 0,
    reservedAmount: 0,
    paymentMethod: null,
    coupon: [],
    partialObject: false,
    registrationType: 'DEFAULT_CHECKOUT',
}

const opportunityReducer = (state = opportunityDefault, action) => {
    switch (action.type) {
        case 'SET_CHECKOUT_OPPORTUNITY':
            return action.payload;
        case 'SET_CHECKOUT_OPPORTUNITY_ID':
            return { ...state, id: action.payload };
        case 'SET_CHECKOUT_OPPORTUNITY_CUSTOMER_ID':
            return { ...state, customerId: action.payload };
        case 'ADD_CHECKOUT_OPPORTUNITY_PROGRAM':
            return { ...state, programs: [...state.programs, action.payload] };
        case 'ADD_CHECKOUT_OPPORTUNITY_COURSE':
            return { ...state, courses: [...state.courses, action.payload] };
        case 'ADD_CHECKOUT_OPPORTUNITY_ATTACHMENT':
            return { ...state, attachments: [...state.attachments, action.payload] };
        case 'SET_CHECKOUT_OPPORTUNITY_ATTACHMENTS':
            return { ...state, attachments: action.payload }
        case 'SET_CHECKOUT_OPPORTUNITY_EDUCATIONAL_GOAL':
            return { ...state, educationalGoal: action.payload };
        case 'SET_CHECKOUT_OPPORTUNITY_COMMENT':
            return { ...state, comment: action.payload };
        case 'SET_CHECKOUT_OPPORTUNITY_TRANSACTION_ID':
            return { ...state, transactionId: action.payload };
        case 'SET_CHECKOUT_OPPORTUNITY_AMOUNT':
            return { ...state, amount: action.payload };
        case 'SET_CHECKOUT_OPPORTUNITY_PAYABLE_AMOUNT':
            return { ...state, payableAmount: action.payload };
        case 'SET_CHECKOUT_OPPORTUNITY_RESERVED_AMOUNT':
            return { ...state, reservedAmount: action.payload };
        case 'SET_CHECKOUT_OPPORTUNITY_PAYMENT_METHOD':
            return { ...state, paymentMethod: action.payload };
        case 'SET_CHECKOUT_OPPORTUNITY_COUPON':
            return { ...state, coupon: action.payload };
        case 'SET_CHECKOUT_OPPORTUNITY_PARTIAL_OBJECT':
            return { ...state, partialObject: action.payload };
        case 'SET_CHECKOUT_OPPORTUNITY_REGISTRATION_TYPE':
            return { ...state, registrationType: action.payload };
        case 'REMOVE_CHECKOUT_OPPORTUNITY_COURSE':
            return { ...state, courses: state.courses.filter(p => p.offeringId !== action.payload.offeringId) };
        case 'REMOVE_CHECKOUT_OPPORTUNITY_PROGRAM':
            return { ...state, programs: state.programs.filter(p => p.id !== action.payload.id) };
        case 'REMOVE_CHECKOUT_OPPORTUNITY_ATTACHMENT':
            return { ...state, attachments: state.attachments.filter(a => a.name !== action.payload.name) };
        case 'RESET_CHECKOUT_OPPORTUNITY_ATTACHMENTS':
            return { ...state, attachments: [], skipAttachments: null };
        case 'RESET_CHECKOUT_OPPORTUNITY':
            return opportunityDefault;
        default:
            return state;
    }
}

export const setCheckoutOpportunity = opportunity => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_OPPORTUNITY', payload: opportunity });
}

export const setCheckoutOpportunityId = id => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_OPPORTUNITY_ID', payload: id });
}

export const setCheckoutOpportunityCustomerId = customerId => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_OPPORTUNITY_CUSTOMER_ID', payload: customerId });
}

export const addCheckoutOpportunityProgram = program => dispatch => {
    dispatch({ type: 'ADD_CHECKOUT_OPPORTUNITY_PROGRAM', payload: program });
}

export const addCheckoutOpportunityCourse = course => dispatch => {
    dispatch({ type: 'ADD_CHECKOUT_OPPORTUNITY_COURSE', payload: course });
}

export const addCheckoutOpportunityAttachment = attachment => dispatch => {
    dispatch({ type: 'ADD_CHECKOUT_OPPORTUNITY_ATTACHMENT', payload: attachment });
}

export const setCheckoutOpportunityAttachments = attachments => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_OPPORTUNITY_ATTACHMENTS', payload: attachments });
}

export const setCheckountOpportunityEducationalGoal = goal => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_OPPORTUNITY_EDUCATIONAL_GOAL', payload: goal });
}

export const setCheckoutOpportunityComment = note => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_OPPORTUNITY_COMMENT', payload: note });
}

export const setCheckoutOpportunityTransactionId = transactionId => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_OPPORTUNITY_TRANSACTION_ID', payload: transactionId });
}

export const setCheckoutOpportunityAmount = amount => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_OPPORTUNITY_AMOUNT', payload: amount });
}

export const setCheckoutOpportunityPayableAmount = payableAmount => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_OPPORTUNITY_PAYABLE_AMOUNT', payload: payableAmount });
}

export const setCheckoutOpportunityReserversdAmount = reserversdAmount => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_OPPORTUNITY_RESERVED_AMOUNT', payload: reserversdAmount });
}

export const setCheckoutOpportunityPaymentMethod = paymentMethod => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_OPPORTUNITY_PAYMENT_METHOD', payload: paymentMethod });
}

export const setCheckoutOpportunityCoupon = coupon => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_OPPORTUNITY_COUPON', payload: coupon });
}

export const setCheckoutOpportunityPartialObject = partialObject => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_OPPORTUNITY_PARTIAL_OBJECT', payload: partialObject });
}

export const setCheckoutOpportunityRegistrationType = registrationType => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_OPPORTUNITY_REGISTRATION_TYPE', payload: registrationType });
}

export const removeCheckoutOpportunityCourse = course => dispatch => {
    dispatch({ type: 'REMOVE_CHECKOUT_OPPORTUNITY_COURSE', payload: course });
}

export const removeCheckoutOpportunityProgram = program => dispatch => {
    dispatch({ type: 'REMOVE_CHECKOUT_OPPORTUNITY_PROGRAM', payload: program });
}

export const removeCheckoutOpportunityAttachment = attachment => dispatch => {
    dispatch({ type: 'REMOVE_CHECKOUT_OPPORTUNITY_ATTACHMENT', payload: attachment });
}

export const resetCheckoutOpportunityAttachments = () => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_OPPORTUNITY_ATTACHMENTS', payload: [] });
}

export const resetCheckoutOpportunity = () => dispatch => {
    dispatch({ type: 'RESET_CHECKOUT_OPPORTUNITY', payload: null });
}

/*
|--------------------------------------------------------------------------
|  COURSE SEARCH INPUT VALUE REDUCER
|--------------------------------------------------------------------------
|
*/
const timeplanPeriodReducer = (state = '', action) => {
    switch (action.type) {
        case 'SET_TIMEPLAN_PERIOD':
            return action.payload;
        default:
            return state;
    }
}

export const setTimeplanPeriod = val => dispatch => {
    dispatch({ type: 'SET_TIMEPLAN_PERIOD', payload: val });
}

/*
|--------------------------------------------------------------------------
|  CHAT REDUCER
|--------------------------------------------------------------------------
|
*/
const chatDefault = {
    horizontalPadding: 20,
    verticalPadding: 20,
}

const chatReducer = (state = chatDefault, action) => {
    switch (action.type) {
        case 'SET_CHAT_HORIZONTAL_PADDING':
            return { ...state, horizontalPadding: action.payload };
        case 'SET_CHAT_VERTICAL_PADDING':
            return { ...state, verticalPadding: action.payload };
        case 'RESET_CHAT':
            return chatDefault;
        default:
            return state;
    }
}

export const setChatHorizontalPadding = padding => dispatch => {
    dispatch({ type: 'SET_CHAT_HORIZONTAL_PADDING', payload: padding });
}

export const setChatVerticalPadding = padding => dispatch => {
    dispatch({ type: 'SET_CHAT_VERTICAL_PADDING', payload: padding });
}

export const resetChat = () => dispatch => {
    dispatch({ type: 'RESET_CHAT', payload: null });
}


/*
|--------------------------------------------------------------------------
|  TIME SCHEDULER
|--------------------------------------------------------------------------
|
*/

const timeScheduleDefault = {
    autumnSchemaVariants: [],
    springSchemaVariants: [],
    autumnSchemaCourseOccasionIds: [],
    springSchemaCourseOccasionIds: [],
}

const timeScheduleReducer = (state = timeScheduleDefault, action) => {
    switch (action.type) {
        case 'SET_CHECKOUT_TIME_SCHEDULER_AUTUMN_VARIANTS':
            return { ...state, autumnSchemaVariants: [...state.autumnSchemaVariants, action.payload] };
        case 'SET_CHECKOUT_TIME_SCHEDULER_SPRING_VARIANTS':
            return { ...state, springSchemaVariants: [...state.springSchemaVariants, action.payload] };
        case 'SET_CHECKOUT_AUTUMN_TIME_SCHEDULER_COURSE_OCCASION_ID':
            return { ...state, autumnSchemaCourseOccasionIds: [...state.autumnSchemaCourseOccasionIds, action.payload] };
        case 'SET_CHECKOUT_SPRING_TIME_SCHEDULER_COURSE_OCCASION_ID':
            return { ...state, springSchemaCourseOccasionIds: [...state.springSchemaCourseOccasionIds, action.payload] };
        case 'RESET_CHECKOUT_AUTUMN_TIME_SCHEDULER_COURSE_OCCASION_ID':
            return { ...state, autumnSchemaCourseOccasionIds: [] };
        case 'RESET_CHECKOUT_SPRING_TIME_SCHEDULER_COURSE_OCCASION_ID':
            return { ...state, springSchemaCourseOccasionIds: [] };
        default:
            return state;
    }
}

export const setCheckoutTimeSchedulerAutumnVariants = variants => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_TIME_SCHEDULER_AUTUMN_VARIANTS', payload: variants });
}

export const setCheckoutTimeSchedulerSpringVariants = variants => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_TIME_SCHEDULER_SPRING_VARIANTS', payload: variants });
}

export const setCheckoutAutumnTimeScheduleSlots = courseOccasionIds => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_AUTUMN_TIME_SCHEDULER_COURSE_OCCASION_ID', payload: courseOccasionIds });
}

export const setCheckoutSpringTimeScheduleSlots = courseOccasionIds => dispatch => {
    dispatch({ type: 'SET_CHECKOUT_SPRING_TIME_SCHEDULER_COURSE_OCCASION_ID', payload: courseOccasionIds });
}

export const resetCheckoutAutumnTimeScheduleSlots = () => dispatch => {
    dispatch({ type: 'RESET_CHECKOUT_AUTUMN_TIME_SCHEDULER_COURSE_OCCASION_ID', payload: null });
}

export const resetCheckoutSpringTimeScheduleSlots = () => dispatch => {
    dispatch({ type: 'RESET_CHECKOUT_SPRING_TIME_SCHEDULER_COURSE_OCCASION_ID', payload: null });
}

/*
|--------------------------------------------------------------------------
|  COMBINED REDUCERS
|--------------------------------------------------------------------------
|
*/
const reducers = combineReducers({
    menus: menusReducer,
    currentView: currentViewReducer,
    pages: pagesReducer,
    calculator: calculatorReducer,
    courses: coursesReducer,
    programs: programsReducer,
    privateTutoring: privateTutoringReducer,
    emne: emneReducer,
    blogKategori: kategoriReducer,
    categories: categoriesReducer,
    academicAreas: academicAreasReducer,
    fagkategori: fagkategoriReducer,
    bookMeeting: bookMeetingReducer,
    importantDates: importantDatesReducer,
    cart: cartReducer,
    checkout: checkoutReducer,
    customer: customerReducer,
    opportunity: opportunityReducer,
    productSearchKeyword: productSearchKeywordReducer,
    productsFilter: productsFilterReducer,
    slots: slotsReducer,
    timeplanPeriod: timeplanPeriodReducer,
    employees: employeesReducer,
    blog: blogReducer,
    chat: chatReducer,
    timeSchedule: timeScheduleReducer,
});

/*
|--------------------------------------------------------------------------
|  Store
|--------------------------------------------------------------------------
|
*/
const persistConfig = {
    key: 'bjorknes',
    storage,
    blacklist: [
        'currentView',
        'calculator',
        'bookMeeting',
        'checkout',
        'customer',
        'opportunity',
        'productSearchKeyword',
        'productsFilter'
    ]
}

export const store = createStore(
    persistReducer(persistConfig, reducers),
    {},
    compose(applyMiddleware(reduxThunk))
);

export const persistor = persistStore(store);

export const maybePurgeStore = persistor => {
    if (process.env.NODE_ENV === 'development') {
        persistor.purge();
        return;
    }

    const currentPersistorKey = document.body.getAttribute('data-persistor-key');
    const savedPersistorKey = window.localStorage.getItem('baa-persistorKey');
    const tomorrow = getFutureDate(4);
    let expirationDate = window.localStorage.getItem('expiration-date');
    let needToRefreshStore = false;

    if (!savedPersistorKey) {
        window.localStorage.setItem('baa-persistorKey', currentPersistorKey);
    }

    if (!expirationDate || !isValidDate(new Date(expirationDate))) {
        window.localStorage.setItem('expiration-date', tomorrow.toISOString());
        expirationDate = window.localStorage.getItem('expiration-date');
    }

    let cutoffCacheDate = new Date('2026-04-29T12:00:00.000Z');
    let cutoffCacheExperirationDate = cutoffCacheDate > new Date(expirationDate);
    console.log('cutoffCacheExperirationDate', cutoffCacheExperirationDate);

    // Need to refresh the Redux store if expirationDate its outdated or
    // the persistorKey changed (database changed)
    needToRefreshStore = (new Date() >= new Date(expirationDate)) || (savedPersistorKey && savedPersistorKey !== currentPersistorKey);

    if (needToRefreshStore || cutoffCacheExperirationDate) {
        console.log('needToRefreshStore or cutoffCacheExperirationDate');
        window.localStorage.setItem('expiration-date', tomorrow.toISOString());
        window.localStorage.setItem('baa-persistorKey', currentPersistorKey);
        persistor.purge(); // persistor.purge() is the responsible for update the "bjorknes:persistor"
    }
}



// WEBPACK FOOTER //
// ./src/store.js